import Vue from 'vue';
import * as types from '../mutation-types';
import ContactAPI from '../../api/contacts';
import ConversationApi from '../../api/conversations';

const state = {
  records: {},
  uiFlags: {
    isFetching: false,
  },

  // twilo_call_state
  twilioCall: {
    callParams:null,   // direction = incomming | outgoing,
    callInstance: null,   // Twilio call object (for disconnect, mute, etc.)
    isCalling:false,
    callStatus: "",       //  "started",in_process, ended, error
    contact:{
      name:"",
      phone_number:"",
    },
  },
  callDuration: 0,

};

export const getters = {
  getUIFlags($state) {
    return $state.uiFlags;
  },
  getContactConversation: $state => id => {
    return $state.records[Number(id)] || [];
  },
  getTwilioCall: ($state) => $state.twilioCall,
  getCallDuration: (state) => state.callDuration,
};

export const actions = {
  create: async ({ commit }, params) => {
    commit(types.default.SET_CONTACT_CONVERSATIONS_UI_FLAG, {
      isCreating: true,
    });
    const {
      inboxId,
      message,
      contactId,
      sourceId,
      mailSubject,
      assigneeId,
    } = params;
    try {
      const { data } = await ConversationApi.create({
        inbox_id: inboxId,
        contact_id: contactId,
        source_id: sourceId,
        additional_attributes: {
          mail_subject: mailSubject,
        },
        message,
        assignee_id: assigneeId,
      });
      commit(types.default.ADD_CONTACT_CONVERSATION, {
        id: contactId,
        data,
      });
      return data;
    } catch (error) {
      console.log(error, 'error');
      throw error;
    } finally {
      commit(types.default.SET_CONTACT_CONVERSATIONS_UI_FLAG, {
        isCreating: false,
      });
    }
  },
  deleteLastContactInbox: async () => {
    try {
      await ConversationApi.deleteContactInbox();
    } catch (error) {
      console.log(error);
    }
  },
  get: async ({ commit }, contactId) => {
    commit(types.default.SET_CONTACT_CONVERSATIONS_UI_FLAG, {
      isFetching: true,
    });
    try {
      const response = await ContactAPI.getConversations(contactId);
      commit(types.default.SET_CONTACT_CONVERSATIONS, {
        id: contactId,
        data: response.data.payload,
      });
      commit(types.default.SET_ALL_CONVERSATION, response.data.payload, {
        root: true,
      });
      commit(
        types.default.SET_lAST_CONVERSATION_ACTIVITY,
        response.data.payload,
        {
          root: true,
        }
      );
      commit(types.default.SET_CONTACT_CONVERSATIONS_UI_FLAG, {
        isFetching: false,
      });
    } catch (error) {
      commit(types.default.SET_CONTACT_CONVERSATIONS_UI_FLAG, {
        isFetching: false,
      });
    }
  },

  // --- Twilio Call Actions ---
  setIncomingCall({ commit }, callPayload) {
    commit(types.default.SET_TWL_INCOMMING_CALL, callPayload);
  },
  setOutgoingCall({ commit }, callPayload) {
    commit(types.default.SET_TWL_OUTGOING_CALL, callPayload);
  },
  endCall({ commit }) {
    commit(types.default.SET_TWL_END_CALL);
  },
  setCallStatus({ commit },status) {
    commit(types.default.SET_TWL_CALL_STATUS,status);
  },
  clearTwilioCall({ commit }) {
    commit(types.default.CLEAR_TWL_CALL);
  },
  updateCallContact({ commit },data) {
    commit(types.default.UPDATE_TWL_CALL_CONTACT,data);
  },
  updaeCallDuration({ commit },data) {
    commit(types.default.UPDATE_TWL_CALL_DURATION,data);
  },






};

export const mutations = {
  [types.default.SET_CONTACT_CONVERSATIONS_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },
  [types.default.SET_CONTACT_CONVERSATIONS]: ($state, { id, data }) => {
    Vue.set($state.records, id, data);
  },
  [types.default.ADD_CONTACT_CONVERSATION]: ($state, { id, data }) => {
    const conversations = $state.records[id] || [];
    Vue.set($state.records, id, [...conversations, data]);
  },
  [types.default.DELETE_CONTACT_CONVERSATION]: ($state, id) => {
    Vue.delete($state.records, id);
  },


    // --- Twilio Call Mutations ---
    [types.default.SET_TWL_INCOMMING_CALL]($state, { call, params,contact }) {
      $state.twilioCall.callInstance = call;
      $state.twilioCall.callParams = params;
      $state.twilioCall.contact = contact;
      $state.twilioCall.isCalling = true;
    },

    [types.default.SET_TWL_OUTGOING_CALL]($state, { call, params,contact }) {
      $state.twilioCall.callInstance = call;
      $state.twilioCall.callParams = params;
      $state.twilioCall.contact = contact;
      $state.twilioCall.isCalling = true;
    },

    [types.default.SET_TWL_END_CALL]($state) {
      if ($state.twilioCall.callInstance) {
        $state.twilioCall.callInstance.disconnect(); // ensure cleanup
      }
    },
    [types.default.CLEAR_TWL_CALL]($state) {
      $state.twilioCall.callInstance = null;
      $state.twilioCall.callParams = null;
      $state.twilioCall.contact = {};
      $state.twilioCall.isCalling = false;
    },

    [types.default.SET_TWL_CALL_STATUS]($state, status) {
      $state.twilioCall.callStatus  = status;
    },
    [types.default.UPDATE_TWL_CALL_CONTACT]($state, contact) {
      $state.twilioCall.contact = contact;
    },
    [types.default.UPDATE_TWL_CALL_DURATION]($state, data) {
      $state.callDuration = data;
    },


};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
